import { AnexoSolicitacao } from 'model/solicitacao/AnexoSolicitacao';
import { FuncoesUploadArquivo } from 'view/component/Upload/InterfacesUpload';
import { MetadadosArquivo } from 'view/component/Upload/model/MetadadosArquivo';
import { Api } from '../Api';
import { ApiAxios } from '../ApiAxios';


export class ApiAnexoSolicitacao {
  static enviarAnexo(): FuncoesUploadArquivo {
    return {
      gerarEnderecoEnvio: async (metadados: MetadadosArquivo) => {
        const response = await ApiAxios.instance.post(`/reinos/${Api.REINO_PADRAO}/solicitacoes/anexos`, metadados)
        return response.data
      },
      // Consolidação automática não utilizada no envio de anexo de solicitação
      consolidarArquivo: async (idArquivo: string) => {
        const idSolicitacao = 1;
        return await ApiAxios.instance.post(`/reinos/${Api.REINO_PADRAO}/solicitacoes/${idSolicitacao}/anexos/${idArquivo}/concluir`);
      }
    }
  }

  static async getEnderecoAnexo(idReino: number, idSolicitacao: number, idAnexo: string) {
    const url = `/reinos/${idReino}/solicitacoes/${idSolicitacao}/anexos/${idAnexo}?redirecionar=false`;

    const response = await ApiAxios.instance.get(url);
    return response.data
  }

  static async findAnexos(idSolicitacao: number): Promise<AnexoSolicitacao[]> {
    const url = `/reinos/${Api.REINO_PADRAO}/solicitacoes/${idSolicitacao}/anexos`;

    const response = await ApiAxios.instance.get(url)
    return response.data
  }
}
